/**
 * Abruf-Helfer des Seiten-Editors (Spec § 5). Pfade laut node-app/src/routes/lpFunnel/editor.ts.
 * Die Sitzung ist POST (sie legt serverseitig Zustand an).
 */
import { api, fetchData } from '../../../../helpers/apiUtils';
import type { EditModeRenderResponse, FunnelPageType, PatchFunnelResult } from '../api';

/** Antwort von POST …/edit-session: Vertrag + fertiges srcdoc-Dokument (editMode.EditSessionResponse). */
export interface EditSession extends EditModeRenderResponse {
  document: string;
  expiresAt: number;
  pageType: FunnelPageType;
}

export interface EditSaveResult extends PatchFunnelResult {
  unveraendert: boolean;
}

const seite = (webinarId: string, pageType: FunnelPageType) =>
  `/api/webinar-lp/funnel/${encodeURIComponent(webinarId)}/${pageType}`;

export function startEditSession(webinarId: string, pageType: FunnelPageType) {
  return fetchData<EditSession>(`${seite(webinarId, pageType)}/edit-session`, {
    method: 'POST',
    body: '{}',
  });
}

export function saveEditSession(
  webinarId: string,
  pageType: FunnelPageType,
  body: { sessionKey: string; ausgangsHash: string; bodyHtml: string },
) {
  return fetchData<EditSaveResult>(`${seite(webinarId, pageType)}/edit-save`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

/** Bild nach Bunny (lp-pages/funnel/<sha1>.<ext>) — gleiche Route wie Kopf-/Referentenbild. */
export async function uploadFunnelImage(file: File): Promise<{ url?: string; error?: string }> {
  const form = new FormData();
  form.append('image', file);
  try {
    const res = await api.post('/api/webinar-lp/upload-image?kind=funnel', form);
    const url = res.data?.data?.url;
    return typeof url === 'string' ? { url } : { error: res.data?.error || 'Upload ohne URL' };
  } catch (e: any) {
    return { error: e?.response?.data?.error || e?.message || 'Upload fehlgeschlagen' };
  }
}
